import { detect } from 'detect-browser';
import { SmoLanguage } from '../Models/Smo/SmoLanguage';

const browser = detect();
const os = browser?.os ?? 'linux';

export const IS_DEV: boolean = process.env.NODE_ENV === 'development';
export const IS_MAC_OS: boolean = os === 'Mac OS';
export const IS_WINDOWS: boolean = os === 'win32';
export const BACK_URL: string = process.env.REACT_APP_API_BASE_URL ?? '';
export const CLIENT_URL: string = process.env.REACT_APP_CLIENT_BASE_URL ?? '';
export const DEFAULT_GAME_LANGUAGE = SmoLanguage.english;
export const DEFAULT_WIDGET_SCALE: number = 75;
